<template>
  <div class="statistic-widget-total-statuses">
    <h5 class="title mb-3">Statuses</h5>
    <div class="no-gutters row scrollbar">
      <div v-for="(item, index) in data" :key="item.label" :class="`col-12 col-md-${col.md} col-lg-${col.lg}`">
        <div class="widget-content">
          <div class="widget-content-wrapper">
            <div class="widget-content-left">
              <div class="widget-heading">{{ item.label }}</div>
            </div>
            <div class="widget-content-right">
              <div :class="`widget-numbers ${styles[index % styles.length].text}`">
                {{ item.number }}
              </div>
            </div>
          </div>
          <div class="widget-subheading">
            <small class="d-block">
              <span class="has-tip" data-title="Sale Price">{{ item.saleLabel }}</span>
            </small>
            <small class="d-block">
              <span class="has-tip" data-title="Purchase Price">{{ item.purchaseLabel }}</span>
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      col: {
        md: 12,
        lg: 6
      },
      styles: [
        {
          text: 'text-warning',
          progressbar: 'bg-warning'
        },
        {
          text: 'text-danger',
          progressbar: 'bg-danger'
        },
        {
          text: 'text-primary',
          progressbar: 'bg-primary'
        },
        {
          text: 'text-success',
          progressbar: 'bg-success'
        }
      ]
    }
  },
  computed: {
    data() {
      let data = this.config.data || {}
      Object.entries(data).forEach(([, values]) => {
        values.saleLabel = this.priceLabel(values.sale)
        values.purchaseLabel = this.priceLabel(values.purchase)
      })
      return data
    }
  },
  methods: {
    priceLabel(prices) {
      let html = []
      Object.entries(prices).forEach(([, value]) => {
        if (value.price > 0) {
          html.push(`${new Intl.NumberFormat().format(value.price || 0)}${value.currency}`)
        }
      })
      return html.join(' - ')
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.statistic-widget-total-statuses {
  .row {
    position: relative;
    z-index: 9;
    max-height: 350px;
    overflow: auto;
    margin: 0 -15px 0 -15px;
  }
  .widget-content-left {
    cursor: pointer;
  }
  .widget-subheading {
    opacity: 0.5;
  }
  .widget-content {
    padding: 0 1rem;
  }
}
</style>
